import { useState, useMemo } from "react";
import { useDispatch } from "react-redux";

import {
  approveAiSkuMappingRecommendation,
  updateAiSkuMappingRecommendation,
  decrementUnreviewedRecommendationsCount,
  rejectAiSkuMappingRecommendation,
} from "../../../actions/aiSkuMappingActions";
import { ACTION, STATUS } from "../constants";

const useDecideAiSkuMapping = (id, suggestedDentiraMatch, labProduct) => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [decisionState, setDecisionState] = useState(ACTION.UNDECIDED);

  const decisionStrategies = useMemo(
    () => ({
      UNDECIDED: {
        [ACTION.APPROVE]: async () => {
          const result = await dispatch(
            approveAiSkuMappingRecommendation(id, {
              supplier: labProduct.supplier,
              dentiraProductCode: suggestedDentiraMatch.code,
              labProductId: labProduct.supplier_product_id,
              createMapping: true,
            }),
          );

          if (result !== null && result !== undefined) {
            setDecisionState(ACTION.APPROVE);
            await dispatch(decrementUnreviewedRecommendationsCount());
          }
        },
        [ACTION.REJECT]: async () => {
          const result = await dispatch(
            rejectAiSkuMappingRecommendation(id, {
              supplier: labProduct.supplier,
              dentiraProductCode: suggestedDentiraMatch.code,
              labProductId: labProduct.supplier_product_id,
              deleteMapping: false,
            }),
          );
          if (result !== null && result !== undefined) {
            setDecisionState(ACTION.REJECT);
            await dispatch(decrementUnreviewedRecommendationsCount());
          }
        },
      },
      DECIDED: {
        [ACTION.APPROVE]: async () => {
          const result = await dispatch(
            updateAiSkuMappingRecommendation(id, {
              status: STATUS.MAPPED,
              supplier: labProduct.supplier,
              dentiraProductCode: suggestedDentiraMatch.code,
              labProductId: labProduct.supplier_product_id,
              createMapping: true,
            }),
          );
          if (result !== null && result !== undefined) {
            setDecisionState(ACTION.APPROVE);
          }
        },
        [ACTION.REJECT]: async () => {
          const result = await dispatch(
            updateAiSkuMappingRecommendation(id, {
              status: STATUS.UNMAPPED,
              supplier: labProduct.supplier,
              dentiraProductCode: suggestedDentiraMatch.code,
              labProductId: labProduct.supplier_product_id,
              deleteMapping: true,
            }),
          );
          if (result !== null && result !== undefined) {
            setDecisionState(ACTION.REJECT);
          }
        },
      },
    }),
    [dispatch, id, suggestedDentiraMatch, labProduct],
  );

  const decideAiSkuMapping = async (action) => {
    const currentState =
      decisionState === ACTION.UNDECIDED ? "UNDECIDED" : "DECIDED";
    await decisionStrategies[currentState][action]();
  };

  return {
    isEditing,
    setIsEditing,
    decisionState,
    decideAiSkuMapping,
    ACTION,
  };
};

export default useDecideAiSkuMapping;
